import { Link } from "react-router-dom";
import logoImg from "../../assets/images/logo.png";
import logoWhiteImg from "../../assets/images/logo_white.png";
import MenuDropdown from "../MenuDropdown";

function TopNavigation({
  toggleHamburger,
  toggleDarkMode,
  handleLogout,
  darkMode,
  user,
}) {
  return (
    <div className="shadow-md sticky top-0 cxl:shadow-none w-full z-[100] bg-primary dark:bg-darkModeBg dark:text-darkWhite h-[77px] border-b-[6px] border-white dark:border-[#333]">
      <div className="w-full h-full flex justify-between items-center px-6">
        {/* Left side content */}
        <div className="flex gap-6">
          <button
            className="block cxl:hidden hover:text-secondary transition-colors duration-150"
            onClick={toggleHamburger}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-7 h-7"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
          <Link to="/" className="cxl:hidden block">
            <img
              src={!darkMode ? logoWhiteImg : logoImg}
              className="w-[7rem] h-auto"
              alt=""
            />
          </Link>
        </div>
        {/* Right side content */}
        <div className="pr-8 flex gap-4">
          <button
            onClick={toggleDarkMode}
            title="Toggle light/dark mode"
            className="p-2 px-3 duration-200 transition-colors rounded-md hover:bg-[#2794eb]/10"
          >
            <svg
              viewBox="0 0 16 16"
              width="18px"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
              <path
                className="fill-secondary"
                d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"
              />
            </svg>
          </button>
          <MenuDropdown handleLogout={handleLogout} user={user} />
        </div>
      </div>
    </div>
  );
}

export default TopNavigation;
